import { z } from 'zod/v3';

// ============================================================================
// Placement Model 스키마
// ============================================================================

/**
 * GNB 네비게이션 바 응답 스키마
 * @see GET /api/market-place/placements/navigation-bars
 */
export const placementNavigationBarSchema = z.object({
  /** ad group ID */
  adGroupId: z.number(),
  /** GNB 카테고리 ID */
  categoryId: z.string().optional(),
  /** GNB 카테고리 명 */
  categoryName: z.string().optional(),
  /** GNB 카테고리 이미지 URL */
  categorySrc: z.string().optional(),
  /** GNB 카테고리 랜딩 링크 */
  categoryUrl: z.string().optional(),
  /** creative ID */
  creativeId: z.number(),
  /** 지면 명 */
  name: z.string().optional(),
  /** GNB 카테고리 Offer Id */
  offerId: z.string().optional(),
  /** GNB 카테고리 Showcase Id */
  showcaseId: z.string().optional(),
});
export type PlacementNavigationBar = z.infer<
  typeof placementNavigationBarSchema
>;

/**
 * 지면 배너 응답 스키마
 * @see GET /api/market-place/v1/placements/banners
 */
export const placementBannerSchema = z.object({
  /** ad group ID */
  adGroupId: z.number(),
  /** 버튼 텍스트 */
  buttonText: z.string().optional(),
  /** 배너 내용 */
  content: z.string().optional(),
  /** creative ID */
  creativeId: z.number(),
  /** 배너 이미지 URL */
  imageUrl: z.string().optional(),
  /** 배너 랜딩 URL */
  landingUrl: z.string().optional(),
  /** 지면 명 */
  name: z.string().optional(),
  /** 배너 타이틀 */
  title: z.string().optional(),
  /** 배너 variant */
  variant: z.string().optional(),
});
export type PlacementBanner = z.infer<typeof placementBannerSchema>;

/**
 * 검색 추천 키워드(광고) 응답 스키마
 * @see GET /api/market-place/v1/placements/search-keywords
 */
export const placementSearchKeywordSchema = z.object({
  /** ad group ID */
  adGroupId: z.number(),
  /** creative ID */
  creativeId: z.number(),
  /** 신규 여부 */
  isNew: z.boolean(),
  /** 키워드 */
  keyword: z.string(),
  /** 랜딩 URL */
  landingUrl: z.string(),
  /** 지면 명 */
  name: z.string().optional(),
});
export type PlacementSearchKeyword = z.infer<
  typeof placementSearchKeywordSchema
>;

/**
 * 검색 상단 배너 응답 스키마
 * @see GET /api/market-place/v1/placements/search-top-banners
 */
export const placementSearchTopBannerSchema = z.object({
  /** ad group ID */
  adGroupId: z.number(),
  /** 배너 랜딩 URL */
  bannerUrl: z.string().optional(),
  /** creative ID */
  creativeId: z.number(),
  /** 배너 이미지 URL */
  imageUrl: z.string().optional(),
  /** 지면 명 */
  name: z.string().optional(),
});
export type PlacementSearchTopBanner = z.infer<
  typeof placementSearchTopBannerSchema
>;
